import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import API from 'config/ApiConfig';

export default function UpdatePresensi() {
  const [presensiData, setPresensiData] = useState(null);
  const [tentorData, setTentorData] = useState([]);
  const [siswaData, setSiswaData] = useState([]);
  const [formData, setFormData] = useState({
    tentor_id: '',
    siswa_id: '',
    harga: '',
    pendapatan: '',
    mata_pelajaran: '',
    waktu_pembelajaran: '',
    jam: '',
    durasi: '',
    feedback: '',
    ulasan: ''
  });
  const [fetchError, setFetchError] = useState(null);
  const { presensiId } = useParams();
  let history = useHistory();
   // const API_BASE_URL = 'http://localhost:5000/api/admin';
   const API_BASE_URL = API.API_ADMIN
  const JWT_TOKEN = localStorage.getItem('authToken');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    const fetchTentors = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/tentor`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTentorData(data);
      } catch (error) {
        console.error('Error fetching tentors:', error);
        setFetchError('Failed to fetch tentor data.');
      }
    };

    const fetchSiswaList = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/siswa`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setSiswaData(data);
      } catch (error) {
        console.error('Error fetching siswa list:', error);
        setFetchError('Failed to fetch siswa data.');
      }
    };

    const fetchPresensi = async () => {
      if (!presensiId) return;

      try {
        const response = await fetch(`${API_BASE_URL}/rekap/${presensiId}`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setPresensiData(data);
        setFormData({
          tentor_id: data.tentor_id || '',
          siswa_id: data.siswa_id || '',
          harga: data.harga || '',
          pendapatan: data.pendapatan || '',
          mata_pelajaran: data.mata_pelajaran || '',
          waktu_pembelajaran: data.waktu_pembelajaran || '',
          jam: data.jam || '',
          durasi: data.durasi || '',
          feedback: data.feedback || '',
          ulasan: data.ulasan || ''
        });
      } catch (error) {
        console.error('Error fetching presensi details:', error);
        setFetchError('Failed to fetch presensi details.');
      }
    };

    fetchTentors();
    fetchSiswaList();
    fetchPresensi();
  }, [presensiId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/rekap/${presensiId}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      window.location.href = `/admin/presensi/view/${presensiId}`; // Redirect after successful update
    } catch (error) {
      console.error('Error updating presensi:', error);
      setFetchError('Failed to update presensi.');
    }
  };

  if (fetchError) {
    return <p className="text-red-500 text-xs">{fetchError}</p>;
  }

  if (!presensiData) {
    return <p>Loading...</p>;
  }

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Update Presensi</h3>
      <form onSubmit={handleSubmit} className="space-y-4 mb-2">
        {/* Tentor Dropdown */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Pilih Tentor:</label>
          <select
            name="tentor_id"
            value={formData.tentor_id}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          >
            <option value="">Pilih Tentor</option>
            {tentorData.map((tentor) => (
              <option key={tentor._id} value={tentor._id}>
                {tentor.nama}
              </option>
            ))}
          </select>
        </div>
        {/* Siswa Dropdown */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Pilih Siswa:</label>
          <select
            name="siswa_id"
            value={formData.siswa_id}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          >
            <option value="">Pilih Siswa</option>
            {siswaData.map((siswa) => (
              <option key={siswa._id} value={siswa._id}>
                {siswa.nama}
              </option>
            ))}
          </select>
        </div>
        {/* Harga Input */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Harga:</label>
          <input
            type="number"
            name="harga"
            value={formData.harga}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        {/* Pendapatan Input */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-red-500">Pendapatan Bersih:</label>
          <input
            type="number"
            name="pendapatan"
            value={formData.pendapatan}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        {/* Mata Pelajaran Input */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Mata Pelajaran:</label>
          <input
            type="text"
            name="mata_pelajaran"
            value={formData.mata_pelajaran}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        {/* Waktu Pembelajaran Input */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Waktu Pembelajaran:</label>
          <input
            type="datetime-local"
            name="waktu_pembelajaran"
            value={formData.waktu_pembelajaran}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        {/* Jam Input */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Jam:</label>
          <input
            type="text"
            name="jam"
            value={formData.jam}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        {/* Durasi Input */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Durasi:</label>
          <input
            type="text"
            name="durasi"
            value={formData.durasi}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        {/* Feedback Textarea */}
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Catatan Belajar Siswa:</label>
          <textarea
            name="feedback"
            value={formData.feedback}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div>
        {/* Ulasan Textarea */}
        {/* <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <label className="block font-semibold text-blueGray-600">Ulasan:</label>
          <textarea
            name="ulasan"
            value={formData.ulasan}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-blueGray-300 rounded"
          />
        </div> */}
        {/* Submit and Cancel Buttons */}
        <div className="flex justify-between">
          <button
            type="submit"
           className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
          >
            Update
          </button>
          <button
            type="button"
            onClick={history.goBack}
            className="bg-red-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
          >
            Kembali
          </button>
        </div>
      </form>
    </div>
  );
}
